import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Export = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <g fill="none">
            <path
                fill={color}
                fillRule="nonzero"
                d="M17,9.5 L14.75,9.5 C14.3357864,9.5 14,9.16421356 14,8.75 C14,8.33578644 14.3357864,8 14.75,8 L17,8 C18.1045695,8 19,8.8954305 19,10 L19,18 C19,19.1045695 18.1045695,20 17,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,10 C5,8.8954305 5.8954305,8 7,8 L9.25,8 C9.66421356,8 10,8.33578644 10,8.75 C10,9.16421356 9.66421356,9.5 9.25,9.5 L7,9.5 C6.72385763,9.5 6.5,9.72385763 6.5,10 L6.5,18 C6.5,18.2761424 6.72385763,18.5 7,18.5 L17,18.5 C17.2761424,18.5 17.5,18.2761424 17.5,18 L17.5,10 C17.5,9.72385763 17.2761424,9.5 17,9.5 Z"
            />
            <path
                fill={color}
                d="M11.6,7.4 L9.2,7.4 C8.7581722,7.4 8.4,7.0418278 8.4,6.6 C8.4,6.1581722 8.7581722,5.8 9.2,5.8 L11.6,5.8 L11.6,3.23185162 C11.6,2.8828896 11.8442994,2.6 12.1456579,2.6 C12.2903754,2.6 12.4291656,2.66656989 12.5314963,2.78506505 L15.4401805,6.15321344 C15.6532732,6.39996684 15.6532732,6.80003316 15.4401805,7.04678656 L12.5314963,10.4149349 C12.3184036,10.6616884 11.9729122,10.6616884 11.7598195,10.4149349 C11.6574888,10.2964398 11.6,10.1357259 11.6,9.96814838 L11.6,7.4 Z"
                transform="rotate(-90 12 6.6)"
            />
        </g>
    </StarryUIIcon>
);
